<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>FILTRI</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="3" sm="5" xs="12">
                                <v-select :items="arrYear" v-model="selectedYear" label="Anno"
                                    @change="getMontantiWeek(selectedYear, selectedShop)" item-text="description"
                                    item-value="id">
                                </v-select>
                            </v-col>
                            <v-col md="3" sm="5" xs="12">
                                <div>
                                    <v-select :items="arrShops" v-model="selectedShop" label="Negozi"
                                        @change="getMontantiWeek(selectedYear, selectedShop)" item-text="description"
                                        item-value="id">
                                    </v-select>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th colspan="6" class="text-center header-background">
                                    Giornaliero
                                </th>
                                <th colspan="3" class="text-center header-background">
                                    Annuale
                                </th>
                            </tr>
                            <tr>
                                <th colspan="3" class="text-center col-background-celeste">
                                    Anno in corso
                                </th>
                                <th colspan="2" class="text-center col-background-yellow">
                                    Scorso anno
                                </th>
                                <th class="text-center col-background-grey">
                                    Delta %
                                </th>
                                <th class="text-center  col-background-celeste">
                                    Anno in corso
                                </th>
                                <th class="text-center col-background-yellow">
                                    Scorso anno
                                </th>
                                <th class="text-center col-background-grey">
                                    Delta %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in montanti" :key="index">
                                <td class="col-background-celeste">

                                    {{ item.week }} Week

                                </td>
                                <td class="col-background-celeste">
                                    <small>({{ item.date_interval_cur_ini | foramtDate }} - {{ item.date_interval_cur_fin | foramtDate }})</small>
                                </td>
                                <td class="col-background-grey">
                                    <span v-if="item.current_incasso_week">
                                        {{ item.current_incasso_week | formatEuro }}
                                    </span>
                                </td>
                                <td class="col-background-yellow">
                                    <small>({{ item.date_interval_past_ini | foramtDate }} - {{ item.date_interval_past_fin | foramtDate}})</small>
                                </td>
                                <td class="col-background-grey">{{ item.past_incasso_week | formatEuro }}</td>
                                <td>
                                    <span v-if="item.current_incasso_week" :class="percClass(item.delta)">
                                        {{ item.delta | percRound }} %
                                    </span>
                                </td>
                                <td class="col-background-grey">
                                    <span v-if="item.current_incasso_year">
                                        {{ item.current_incasso_year | formatEuro }}
                                    </span>
                                </td>
                                <td class="col-background-grey">{{ item.past_incasso_year | formatEuro }}
                                </td>
                                <td>
                                    <span v-if="item.current_incasso_year" :class="percClass(item.delta_yearly)">
                                        {{ item.delta_yearly | percRound }} %
                                    </span>
                                </td>

                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss">
.v-data-table::v-deep>.v-data-table__wrapper>table {
    border-spacing: 2px;

    th,
    td {
        border: 1px solid black;
        font-weight: bold;
    }
}


.header-background {
    background-color: #ffdaa3;
}

.col-background-celeste {
    background-color: #e6fefe;
}

.col-background-yellow {
    background-color: #ffffcd;
}

.col-background-grey {
    background-color: #fafcfb;
}

.text-color-red {
    color: red;
}

.text-color-green {
    color: green;
}
</style>
<script>
import requests from "../../requests";
import DialogIncassiVue from "./DialogIncassi.vue";
import moment from "moment";
export default {
    name: "montanti-page",
    components: {
        DialogIncassiVue
    },

    data: () => {
        return {
            menu: false,
            loading: false,
            montanti: [],
            dialog: false,
            arrShops: [],
            selectedShop: 0,
            editIncasso: {},
            panel: 0,
            totali: {},
            arrYear: [],
            selectedYear: 0,
        };
    },
    mounted() {
        console.log("Montanti Mounted.");
        this.selectedYear = this.$moment().format('YYYY');
        this.loading = true;

        for (let i = this.selectedYear; i >= (this.selectedYear - 10); i--) {
            this.arrYear.push({
                id: i,
                description: i
            });
        }

        this.getShopList();
    },
    methods: {
        onCloseDialog() {
            this.dialog = false;
        },
        getShopList() {
            requests.getShopList().then(res => {
                if (window.currentUser.role == "Admin") {
                    this.arrShops = [{
                        description: "TUTTI",
                        id: "tutti",
                    }, ...res.data];
                } else this.arrShops = res.data;
                this.selectedShop = this.arrShops[0].id;
                this.getMontantiWeek(this.selectedYear, this.selectedShop);
            })
        },
        getMontantiWeek(dIni, shopId) {
            requests.getMontantiWeek(dIni, shopId).then(res => {
                this.montanti = res.data;
                this.loading = false;
            });
        },

        percClass(num) {
            if (parseFloat(num) > 0) {
                return 'text-color-green';
            } else if (parseFloat(num) < 0) {
                return 'text-color-red';
            }
            return '';
        },
    },

    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
        percRound(number) {
            if (_.isNaN(number)) return '-';
            return Math.round(number * 100) / 100;
        },
        foramtDate(date){
            let d = moment(date, 'YYYY-MM-DD');
            return d.format('DD/MM');
        }
    },


};
</script>
